import { render } from "./SaveCollectionDialog.vue?vue&type=template&id=211ec318"
import script from "./SaveCollectionDialog.vue?vue&type=script&lang=js"
export * from "./SaveCollectionDialog.vue?vue&type=script&lang=js"

import "./SaveCollectionDialog.vue?vue&type=style&index=0&id=211ec318&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__